import qs from "qs";
import authAxios, { authHeader } from "../data";

const fetchAll = async (request: any) => {
  const response = await authAxios.get("/api/Contracts", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (request: any) => {
  const response = await authAxios.get("/api/Contracts/Count", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/Contracts/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const searchCustomerByNumber = async (number: number) => {
  const response = await authAxios.get(
    "/api/Contracts/Customers?Search=" + number,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const getExcel = async (request: any) => {
  const response = await authAxios.get("/api/Export/Contracts", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const save = async (request: any) => {
  const response = await authAxios.post("/api/Contracts", request, {
    headers: authHeader(),
  });

  return response.data;
};

const searchByNumber = async (number: number) => {
  const response = await authAxios.get(
    "/api/Contracts/ByNumber?Number=" + number,
    {
      headers: authHeader(),
    }
  );

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete(`/api/Contracts/${id}`, {
    headers: authHeader(),
  });

  return response.data;
};

const update = async (id: string, request: any) => {
  const response = await authAxios.put(`/api/Contracts/${id}`, request, {
    headers: authHeader(),
  });

  return response.data;
};

const fetchPayees = async (request: any) => {
  const response = await authAxios.get("/api/ContractPayees", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const saveMailingSettings = async (request: any, id: string) => {
  const result = await authAxios.put(`/api/Contracts/${id}/mailing`, request, {
    headers: authHeader(),
  });

  return result.data;
};

const ContractsService = {
  fetchAll,
  fetchCount,
  fetch,
  searchCustomerByNumber,
  getExcel,
  save,
  searchByNumber,
  remove,
  update,
  fetchPayees,
  saveMailingSettings,
};

export default ContractsService;
